import { PaymentDisplayModel, AnfrageDisplayModel, GlobalEnumsAceMittelabruf, PaymentFoerdersummenDisplayModel, PaymentFoerdersummenDisplayModelFormGroup, LocalizedTextDisplayModel } from '@/api/model-index';
import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { PortalkonfigurationDisplayModel } from '../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { NavigationItem } from '@/core/models/navigation-item.model';
import { NavigationService } from '@/core/services/navigation.service';
import { I18nService } from '@/core/services/i18nService';
import { PaymentService } from '@/core/services/payment.service';

@Component({
    selector: 'app-anfrage-fund-payments',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent {
    public anfrage: AnfrageDisplayModel;
    public payments: PaymentDisplayModel[] = [];
    public fundingAmounts: PaymentFoerdersummenDisplayModel;
    public fundingAmountsForm: PaymentFoerdersummenDisplayModelFormGroup;
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    public navItem: NavigationItem | null;
    public type: GlobalEnumsAceMittelabruf = GlobalEnumsAceMittelabruf.Zahlung;

    constructor(protected route: ActivatedRoute,
        protected languageservice: I18nService,
        protected navigationService: NavigationService,
        protected paymentService: PaymentService
        ) {
        
        this.anfrage = this.route.snapshot.data.anfrage;
        this.fundingAmounts = this.route.snapshot.data.fundingAmounts;
        this.payments = this.fundingAmounts.payments ?? [];
        this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;

        if (this.portalkonfiguration.mittelabrufAbschnitt)
            this.navItem = this.navigationService.getNavItem(this.portalkonfiguration.mittelabrufAbschnitt)
    }

    public get abschnittInfotext(): string {
        let infotext: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.mittelabrufAbschnitt?.infotext);
        return infotext?.text ?? "";
    }
}